import styled from 'styled-components';

import { space } from '@creditornot/alchemy-react/tokens';

const Root = styled.div`
  padding: ${space.broadLarge};
  padding-top: ${space.narrowSmall};
  overflow: auto;
  flex: 1;
`;

type Props = {
  children: React.ReactNode;
};

export const Body = ({ children }: Props) => {
  return <Root>{children}</Root>;
};
